import { Divider, Paper, Typography } from "@mui/material"
import React from "react"

const ComplexFormSection = ({ title, children, className }: { title: string, children: React.ReactNode, className?: string }) => {
  return (
    <div className={className}>
      <Paper elevation={0} sx={{ padding: 2, marginBottom: 2 }}>
        <Divider variant="middle">
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Divider>

        <div>
          <div className="grid grid-cols-2 gap-x-4 gap-y-2">
            {children}
          </div>
        </div>
      </Paper>
    </div>
  )
};

const SimpleFormSection = ({ title, children, className }: { title: string, children: React.ReactNode, className?: string }) => {
  return (
    <div className={className}>
      <Paper elevation={0} sx={{ padding: 2, marginBottom: 2 }}>
        <Divider variant="middle">
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Divider>

        <div>
          <div className="grid gap-x-4 gap-y-2">
            {children}
          </div>
        </div>
      </Paper>
    </div>
  )
};

const SettingSection = ({ title, children, className }: { title: string, children: React.ReactNode, className?: string }) => {
  return (
    <div className={className}>
      <Paper sx={{ padding: 2, marginBottom: 2 }}>
        <Divider variant="middle">
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Divider>

        <div>
          <div className="flex justify-center">
            {children}
          </div>
        </div>
      </Paper>
    </div>
  )
}

const TableSection = ({title, children, className,}: {title: string; children: React.ReactNode; className?: string;}) => {
  return (
    <div className={className}>
      <Paper elevation={0} sx={{ padding: 2, marginBottom: 2 }}>
        <Divider variant="middle">
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Divider>
        
        <div className="w-full">{children}</div> 
      </Paper>
    </div>
  );
};

 
export {
  ComplexFormSection as FormSection,
  SimpleFormSection,
  SettingSection,
  TableSection
};